import axios from 'axios';

const API_BASE_URL = 'https://ott.no1news.in';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // This is important for CSRF protection
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add CSRF token for all requests when available
    const csrfToken = localStorage.getItem('csrfToken');
    if (csrfToken) {
      config.headers['X-CSRFToken'] = csrfToken;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url || '';
    const statusCode = error.response?.status;

    // Auto-logout if check-status returns:
    // 403 = user deactivated/blocked by admin
    // 401 = JWT token expired or invalid (needs re-login)
    if ((statusCode === 403 || statusCode === 401) && requestUrl.includes('check-status')) {
      console.log(`[Auth] check-status returned ${statusCode}, triggering logout`);
      // Clear auth data
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user');
      localStorage.setItem('isAuthenticated', 'false');

      // Get current path for redirect
      const currentPath = window.location.pathname + window.location.search;

      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/login')) {
        // Store current path and redirect to login
        window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
      }
    }
    return Promise.reject(error);
  }
);

export const watchlistAPI = {
  toggle: (contentId) => api.post('/api/watchlist/toggle/', { content_id: contentId }),
  getStatus: (contentId) => api.get(`/api/watchlist/status/?content_id=${contentId}`),
  getList: () => api.get('/api/watchlist/'),
};

export const franchiseAPI = {
  getCodes: () => api.get('/api/subscription-codes/'),
};

export default api;
